export const PRO_GALLERY_CSS_VARS_PREFIX = 'ProGallery';
export const ROOT_COMP_SELECTOR = '.root';
export const VARIANT_COUNT_KEY = 'variant_count';
